export const statusLabels = {
    PENDING: '待双方确认',
    CONFIRMED: '已确认',
    CANCELLED: '已取消',
    CLOSED: '已关闭',
    OPEN: '待处理',
    REPLACE: '补发',
    ACCEPT_LOSS: '接受差异',
    REQUESTED: '待卖方批准',
    APPROVED: '待退货出库',
    SHIPPED: '退货在途',
    RECEIVED: '已收退货',
    REJECTED: '已驳回',
    AVAILABLE: '合格可用',
    QUARANTINE: '待检隔离',
    OPENING: '期初入库',
    ADJUSTMENT: '库存调整',
    SALE_SHIPMENT: '销售出库',
    PURCHASE_RECEIPT: '采购实收入库',
    RETURN_SHIPMENT: '退货出库',
    RETURN_RECEIPT: '退货实收入库',
    LOCAL_SALE: '本企业销售出库',
    LOCAL_PURCHASE: '本企业采购入库',
    PRODUCTION: '生产入库',
    PRODUCTION_USE: '生产领用',
    ACCESSORY_SHIPMENT: '配套随产品出库',
    ACCESSORY_RETURN: '配套随退货退回',
};
export { orderFeed, feedStatus, nextStep, orderPhase, overdueDays, } from './order-feed.js';
export { gramsPer } from './weight.js';
export { skuUsageLabels, canUseSku } from './sku-usage.js';
export { adjustReasons, benchmarkNames, blendedRate, detectMaterial, MATERIAL_CODES, materialLabels, signedPercent, } from './material-adjust.js';
export { CODE_PREFIX, CUSTOM_KEY, customKey, SPEC_PARAMS, SPEC_PRESETS, specMaterial, specParam, specText, } from './sku-spec.js';
export { ROLES, ASSIGNABLE_ROLES, ROLE_PERMISSIONS, roleNames, roleHints, roleLabel, permissionsOf, can, canSeeSide, canSeePrice, seesNoMoney, workbenchOf, } from './permissions.js';
export { daysToDelivery, deliveryLabel, } from './warehouse.js';
export { auditLabels } from './audit.js';
